import { createContext, ReactElement } from 'react';
import PropTypes from 'prop-types';

import ROLES, { ComputedRole } from './roles';

export const RBACContext = createContext<{
  role?: ComputedRole;
  roles: typeof ROLES;
}>({
  roles: ROLES,
});

interface RBACProviderProps {
  children: ReactElement;
  role?: ComputedRole;
}

export default function RBACProvider({ children, role }: RBACProviderProps) {
  return (
    <RBACContext.Provider value={{ role, roles: ROLES }}>
      {children}
    </RBACContext.Provider>
  );
}

RBACProvider.propTypes = {
  children: PropTypes.element.isRequired,
  role: PropTypes.oneOf(Object.keys(ROLES)),
};

RBACProvider.defaultProps = {
  role: undefined,
};
